// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.d-flex.font span{\n  color:#606266;\n  font-size:14px;\n  line-height:40px;\n  padding: 0 12px 0 0;\n  font-weight:700;\n}\n.d-flex{\n  display:flex;\n}\n.nowrap{\n  white-space: nowrap;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
